import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router' ;
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';

import { environment } from '../../../environments/environment';
import { ApiService } from '../../custom-material/Services/api.service';
import { UserModel } from '../../main/Models';
import { globalData } from 'src/app/main/Models/global.model';
import { TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.less']
})
export class LoginComponent implements OnInit {

  show = 'login'; // login | forgot

  username;
  password;

  forgotLink = environment.baseUrl + '/mon-profil/mot-de-passe-perdu';
  failLogin = false;

  @Output()
  signin = new EventEmitter<boolean>();


  constructor( private apiService: ApiService,
               private router: Router,
               private gd: globalData,
               //private sanitizer: DomSanitizer 
               private translocoService: TranslocoService
               ) { }

  ngOnInit():void {}


  login(event): void
  {
  if (event.code !== undefined && event.code !== 'Enter') { return; }

   this.apiService.connect(this.username, this.password)
    .then(res => {
      if (res !== 1) { this.failLogin = true; }
      else {
        this.loadUserProfile();
       }
    });
  }

  forgot(event): void
  {
    if (event.code !== undefined && event.code !== 'Enter') { return; }

    this.apiService.PostToServer('mon-profil/mot-de-passe-perdu', {email: this.username})
    .subscribe(res => {
    });
  }

  loadUserProfile(): void {
    this.apiService.getUserData().then(
      userData => {
        this.gd.connectedUser = new UserModel(userData);
        this.signin.emit(true);
      }
    );
    
  }

  get lang() {
    return this.translocoService.getActiveLang();
  }
  set lang(l) {
        this.translocoService.setActiveLang(l);
  }
}
